var exports = {
  "k": "x620889e6--764ed9--container",
};

module.exports = exports;
